import { type ReactNode } from 'react'

interface AcademyBackgroundProps {
  children: ReactNode
  /** 是否显示粒子装饰（默认 true） */
  particles?: boolean
  visualScope?: 'app' | 'pretest'
  className?: string
}

export default function AcademyBackground({ children, particles = true, visualScope = 'app', className = '' }: AcademyBackgroundProps) {
  const themeClass = visualScope === 'app' ? 'soft-orbit-theme' : ''
  return (
    <div className={`academy-bg ${themeClass} ${className}`.trim()} data-decoration={particles ? 'quiet' : 'none'} data-visual-scope={visualScope}>
      <div className="academy-bg__base" />
      <div className="academy-bg__content">
        {children}
      </div>
    </div>
  )
}
